function withdrawEMoney() {

    let withdrawEMoneyService = [
        {
            name: "Withdraw E Money",
            icon: "Withdraw E-Money",
            logoName: "fee",
            displayService: "withdrawEMoney",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/withdraw-money",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "DASHBOARD",
            },
        ];

        return dashboardArr;
    };

    const WithdrawMoney = () => {
        const profileArr = [
            {
                path: "/index/withdrawMoney",
                name: "Withdraw E money",
                icon: "fee-master",
                logoName: "Withdraw_E_Money",
                flag: "WITHDRAW E MONEY",
            },
        ];
        return profileArr;
    };

    let a = dashboard();
    let b = WithdrawMoney();

    withdrawEMoneyService[0].items = [...a, ...b];

    return withdrawEMoneyService;
}

export default withdrawEMoney;